export default __webpack_public_path__ + "resources/icons/d312-fe4b.webp";